import React from 'react';

function Modal({ onClose, title, children, size = 'medium' }) {
  const sizeClass = size === 'large' ? 'modal-large' : '';
  
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal ${sizeClass}`} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          {title && <h2>{title}</h2>}
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <div className="modal-content" style={{ padding: '18px' }}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default Modal;

